export default [
    {
        path: 'user/list',
        name: 'organization_user_list',
        meta: { isCache: true, icon: 'md-people', hideInMenu: false },
        component: () => import('@/views/organization/user/user-list.vue'),
    },
    {
        path: 'user/add',
        name: 'organization_user_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/organization/user/user-add.vue'),
    },
    {
        path: 'user/edit/:id',
        name: 'organization_user_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/organization/user/user-edit.vue'),
    },
    {
        path: 'user/detail/:id',
        name: 'organization_user_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/organization/user/user-detail.vue'),
    },
];
